// configConstants.js
'use strict';

export const GrowthBookInitStatus = {
  DEFAULT: 'default',
  INITIALIZING: 'initializing',
  UPDATING: 'updating',
  SUCCESS: 'success',
  FAILED: 'failed',
};

export const GROWTHBOOK_DEFAULT_TIMEOUT_MSEC = 5000;
export const REFRESH_INTERVAL_SECONDS = 90;
